// /pages/ContactPage.tsx
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import Button from '../components/common/Button';
import useScrollToTop from '../hooks/hook';

const ThanksPage: React.FC = () => {
  useScrollToTop();

  const handleCompanyClick = () => {
    window.location.href = 'https://starpier.jp/';
  };

  return (
    <div className="l_container">
      <Header />
      <div className="l_thanks">
        <p className="thanks_page_desc">
          お問い合わせありがとうございました。
        </p>
        <Button onClick={handleCompanyClick} className="thanks-button" iconPosition="left"
          iconType="left"
          iconSize={30}>
          トップに戻る
        </Button>
      </div>
      <Footer />
    </div>
  );
};

export default ThanksPage;